<template>
  <div>
    <v-layout wrap>
      <v-flex >
        <c-search-form
            :rows-per-page-items="[10, 20, 50]"
            :form-name="formName"
            :fields="fields"
            :hiddenFields="hiddenFields"
            key-property="programId"
            search-url="/babiProgram/listAll"
            create-url="/babiProgram/save"
            delete-url="/babiProgram/delete"
            form-type="intable"
            custom-create-new
            @createNew="openCreateDialog"
            custom-edit-item
            @editItem="openCreateDialog"
            ref="tableData"
            :reload="timeReload"
            :deleteMulti="false"
            :acceptDelete="false"
            :accept-edit="false"
            :accept-create="false"
            :acceptView="true"
            @viewItem="viewItem"
            @setLastSearchValues="setLastSearchValues"
            :lastSearchValues="lastSearchValues"
            orderBy="asc,desc"
        >
        </c-search-form>
        <material-type-group-create
            :propsItem="category"
            :cDialog="visibleCreateDialog"
            @closeCreateDialog="closeCreateDialog"
            :formCreateName="formCreateName"
            :hiddenFields="hiddenFields"
        />
      </v-flex>
    </v-layout>
  </div>

</template>

<script>
import CSearchForm from "../../../components/form/ManageForm";
import {areaContants} from "@/constants";
import axios from "axios";
import MaterialTypeGroupCreate from "@/views/admin/program/ProgramCreate";

export default {
  name: "warehouse",
  components: {MaterialTypeGroupCreate, CSearchForm},
  data: () => {
    return {
      formName: "lang.program.programType",
      formCreateName: "lang.program.createProgramType",
      category: null,
      visibleCreateDialog: false,
      lastSearchValues: {},
      timeReload: 0,
      hiddenFields: {
        typeId: "0",
      },
      fields: [
        {
          value: "index",
          text: "lang.common.index",
          width: "5%",
          sortable: false,
          headerStyle: "text-align:center",
        },
        {
          value: 'programName',
          text: 'lang.program.programName',
          sortable: false,
          search: true,
          headerStyle: "text-align:center",
          width: "20%",
        },
        // {
        //   value: 'description',
        //   text: 'lang.program.description',
        //   sortable: false,
        //   search: true,
        //   headerStyle: "text-align:center",
        // },
        {
          value: 'levelId',
          text: 'lang.program.levelId',
          width: "10%",
          sortable: false,
          search: true,
          headerStyle: "text-align:center",
          type: "select",
          name: "levelId",
          items: [],
          itemText: "levelNumber",
          itemValue: "levelId",
        },
        {
          value: 'ageId',
          text: 'lang.program.ageId',
          width: "10%",
          sortable: false,
          search: true,
          headerStyle: "text-align:center",
          type: "select",
          name: "ageId",
          items: [],
          itemText: "ageName",
          itemValue: "ageId",
        },
        {
          value: 'weekTotal',
          text: 'lang.program.weekTotal',
          sortable: false,
          search: true,
          headerStyle: "text-align:center",
          width: "20%",
        },
        // {
        //   value: "status",
        //   text: "lang.user.status",
        //   search: true,
        //   headerStyle: "text-align:center",
        //   type: "select",
        //   name: "status",
        //   items: areaContants.areaStatus,
        //   itemText: "text",
        //   itemValue: "value",
        // },
        {
          value: "action",
          text: "lang.common.actions",
          sortable: false,
          compound: true,
          width: "15%",
          headerStyle: "text-align:center",
        },
      ],
    };
  },

  created() {
    let queryParam = this.$route.query;

    let searchImportRequest = queryParam.searchImportRequest;
    if(searchImportRequest !=undefined){
      try{
        this.lastSearchValues = JSON.parse(searchImportRequest);
      } catch (e){

      }
    }
    axios.post(
        process.env.VUE_APP_API_URL + "/babiLevel/listAllName", {status: 1}
    )
        .then(
            (data) => {
              let itemFields = this.fields.filter(function (e) {
                return e.name == "levelId";
              });
              if (itemFields != undefined && itemFields.length > 0) {
                itemFields[0].items = data;
              }
            }
        );

    axios.post(
        process.env.VUE_APP_API_URL + "/kidAge/listAllName", {status: 1}
    )
        .then(
            (data) => {
              let itemFields = this.fields.filter(function (e) {
                return e.name == "ageId";
              });
              if (itemFields != undefined && itemFields.length > 0) {
                itemFields[0].items = data;
              }
            }
        );
  },

  methods: {

    openCreateDialog: function (item = null) {
      if (item == null) {
        this.formCreateName = 'Thêm mới khung chương trình';
        this.getNextCode();
      } else {
        this.category = item;
        this.formCreateName = 'Cập nhật khung chương trình';
        this.visibleCreateDialog = true;
      }
    },
    closeCreateDialog: function () {
      this.category = null;
      this.visibleCreateDialog = false;
      this.timeReload = Math.floor(Math.random() * 100);
    },

    getNextCode: function () {
      axios.get(
          process.env.VUE_APP_API_URL +
          "/autoIncrease/getNextNumber?type=MATERIAL_TYPE_ALLY"
      )
          .then((data) => {
            this.category = Object.assign({}, this.category, {"categoryCode": "MATERIAL_TYPE_ALLY" + data, "status": 1})
            this.visibleCreateDialog = true;
          });
    },
    setLastSearchValues: function (values) {
      //this.lastSearchValues = Object.assign(this.lastSearchValues, {"searchQT":JSON.stringify(values)});
      this.lastSearchValues = Object.assign(this.lastSearchValues, values);
    },
    createParamLastSearch: function (values) {
      const obj1 = {
        searchImportRequest: JSON.stringify(values),
      };
      const obj2 = this.$route.query;
      return {...obj1, ...obj2};
    },
    viewItem: function (item) {
      this.$router.push({
        path: '/babiProgram/view/' + item.programId, query: this.createParamLastSearch(this.lastSearchValues)
      });
    },
  },

  destroyed() {
  },
};
</script>
